import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-950 font-AfacadFluxLight text-white pt-20 pb-8 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Top Section */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          {/* Company Info - Left Side */}
          <div className="lg:col-span-4">
            {/* Logo */}
            <div className="mb-6">
              <h3 className="text-2xl sm:text-3xl font-AfacadFluxLight font-bold text-white tracking-tight">
                VENTURECORP
                <span className="text-purple-400">.</span>
              </h3>
            </div>

            {/* Social Links */}
            <div className="space-y-3">
              <a href="https://www.linkedin.com/company/venturecorp-pvt-ltd/" target="_blank" rel="noopener noreferrer" className="flex items-center text-white hover:text-gray-300 transition-colors">
                Linkedin
                <svg className="w-4 h-4 ml-2 transform rotate-45" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M7 17l9.2-9.2M17 17V7H7" />
                </svg>
              </a>
            </div>
          </div>

          {/* Navigation Columns - Right Side */}
          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-8">
            {/* Company Column */}
            <div>
              <h5 className="text-gray-400 text-sm font-medium mb-4">COMPANY</h5>
              <ul className="space-y-3">
                <li><Link to="/about" className="text-white hover:text-gray-300 transition-colors">About Us</Link></li>
                <li><Link to="/contact" className="text-white hover:text-gray-300 transition-colors">Contact</Link></li>
              </ul>
            </div>

            {/* Services Column */}
            <div>
              <h5 className="text-gray-400 text-sm font-medium mb-4">SERVICES</h5>
              <ul className="space-y-3">
                <li><Link to="/corporate-services" className="text-white hover:text-gray-300 transition-colors">Corporate Services</Link></li>
                <li><Link to="/hr-services" className="text-white hover:text-gray-300 transition-colors">HR Services</Link></li>
                <li><Link to="/accounting-services" className="text-white hover:text-gray-300 transition-colors">Accounting Services</Link></li>
                <li><Link to="/social-media-services" className="text-white hover:text-gray-300 transition-colors">Social Media Services</Link></li>
              </ul>
            </div>

            {/* Solutions Column */}
            <div>
              <h5 className="text-gray-400 text-sm font-medium mb-4">SOLUTIONS</h5>
              <ul className="space-y-3">
                <li><Link to="/co-working-spaces" className="text-white hover:text-gray-300 transition-colors">Co-working Spaces</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Horizontal Links */}
            <div className="flex flex-wrap gap-6 text-sm">
              <Link to="/terms-and-conditions" className="text-white hover:text-gray-300 transition-colors">Terms and Conditions</Link>
              <Link to="/legal" className="text-white hover:text-gray-300 transition-colors">Legal</Link>
            </div>
          </div>

          {/* Copyright and Regulatory */}
          <div className="flex flex-col md:flex-row justify-between items-center mt-6 pt-6 border-t border-gray-700">
            <p className="text-gray-400 text-sm">
              © VentureCorp Capital. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm text-right">
              VentureCorp Capital (Pvt) Ltd is authorised and regulated by the Financial Conduct Authority.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 